import { useRef } from 'react';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

export function useGuessTimezone(): string[] {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const tz = useRef(dayjs.tz.guess());

  return [tz.current];
}

export default useGuessTimezone;
